import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { PlanningGrid } from "@/components/v2/PlanningGrid";
import PlanningSetup from "@/pages/admin/PlanningSetup";
import { Button } from "@/components/ui/button";
import { CalendarDays, Settings2, Info } from "lucide-react";

// Démonstration : planning fictif déjà publié en première vue ; paramétrage avancé en accès secondaire (Dirigeant).
export function DemoPlanning() {
  const { user } = useAuth();
  const [advanced, setAdvanced] = useState(false);
  const admin = user?.role === "admin";
  return (
    <div className="space-y-4" data-testid="demo-planning">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="font-heading text-2xl font-extrabold text-brand-900 flex items-center gap-2"><CalendarDays className="w-6 h-6" />Planning de l'équipe</h1>
          <p className="text-sm text-slate-500 max-w-2xl">Exemple fictif déjà publié : journées, gardes, repos, OFF et congés sur plusieurs semaines. Cliquez sur une case pour voir le détail ; les salariés consultent ce planning dans « Mon planning ».</p>
        </div>
        {admin && <Button variant="outline" data-testid="demo-planning-advanced" onClick={() => setAdvanced(!advanced)} className="h-10"><Settings2 className="w-4 h-4 mr-1" />{advanced ? "Revenir au planning" : "Configuration avancée"}</Button>}
      </div>
      {advanced ? (
        <div className="space-y-3" data-testid="demo-planning-config">
          <p className="rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900 flex items-start gap-2" data-testid="demo-generation-notice"><Info className="w-4 h-4 mt-0.5 shrink-0" />Paramétrage complet du planning. La génération automatique est une fonction en cours de développement : elle est désactivée dans la démonstration.</p>
          <PlanningSetup />
        </div>
      ) : <PlanningGrid canWrite />}
    </div>
  );
}
